import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { doc, onSnapshot } from "firebase/firestore";

export function useClient(env, client) {
  const [loadedClient, setLoadedClient] = useState(false);
  const [clientData, setClientData] = useState(null);

  useEffect(() => {
    setLoadedClient(false);
    if (!client) {
      setLoadedClient(true);
      return () => [];
    }
    let ref = doc(db, "kiosk", env, "client", client);
    const unsub = onSnapshot(ref, (snapshot) => {
      if (snapshot.exists()) {
        setClientData({
          id: snapshot.id,
          ...snapshot.data(),
        });
      } else setClientData(null);
      setLoadedClient(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedClient, clientData };
}